import { mapState, mapActions } from 'vuex';

import {
  accounts as accountsAPI,
} from '@/services';

export default {
  computed: {
    ...mapState({
      token: (state) => state.app.token,
      $_userInfo: (state) => state.user.userInfo,
    }),
    userInfo: {
      get() {
        return this.$_userInfo;
      },
      set(payload) {
        this.setUserData(payload);
      },
    },
  },
  async mounted() {
    const { name: currentRoute } = this.$router.history.current;
    if (currentRoute !== 'login' && this.token) await this.getUserData();
  },
  methods: {
    ...mapActions({
      setUserData: 'user/SET_USER_DATA',
    }),
    async getUserData() {
      await accountsAPI
        .getInfoUser()
        .then(async ({ data }) => {
          this.userInfo = data;
        })
        .catch(() => {
          this.redirectToLogin();
        });
    },
    redirectToLogin() {
      const name = 'login';
      if (this.$route.name !== name) this.$router.push({ name });
    },
  },
};
